module.exports = __webpack_public_path__ + "static/media/ic_call_cut_filled.97d3f2e4.svg";